import { ApAssertion, Assertion, FormattedApAssertion, ServiceOffering } from "@idw-types/data/reference-data/generic";

export const formatApAssertions = (
    apAssertions: Array<ApAssertion>,
    assertions: Array<Assertion>,
    serviceOfferings: Array<ServiceOffering>
): Array<FormattedApAssertion> => {
    return apAssertions.map(apa => formatApAssertion(apa, assertions, serviceOfferings));
};

export const formatApAssertion = (
    apAssertion: ApAssertion,
    assertions: Array<Assertion>,
    serviceOfferings: Array<ServiceOffering>
): FormattedApAssertion => {
    const assertion = assertions.find(a => a.id === apAssertion.assertionID);
    const serviceOffering = serviceOfferings.find(so => so.id === apAssertion.serviceOfferingID);

    return {
        assertion: assertion,
        id: apAssertion.id,
        serviceOffering: serviceOffering,
        status: apAssertion.status
    };
};